export const CREATE_ZENDESK_TICKET = "zendeskState/CREATE_ZENDESK_TICKET";
export const SET_UTM_VALUES = "zendeskState/SET_UTM_VALUES";
